const Availability = isOutOfStock => {
  return isOutOfStock ? 'OutOfStock' : 'InStock';
};

export default Availability;
